<template>
    <div>
        <duplicate-claim-modal></duplicate-claim-modal>
        <attorney-info-component :claimId="model.claim_id" :states="model.states" @update="updateAttorney"></attorney-info-component>
        <div class="row">
            <div class="col-8"></div>
            <div class="col-md-4 align-self-end">
                <select form="claimForm" :disabled="!newClaim" name="client" id="client" v-bind:class="['custom-select mr-3', {'is-invalid' : hasError('client') }, { 'text-primary' : clientId == 0 }]" v-model="clientId" @change="onClientChange($event)" required>
                    <option disabled value="0" hidden>Choose a client</option>
                    <option v-for="option in model.clients" :key="option.id" :value="option.id" v-text="option.name"></option>
                </select> 
                <span v-if="hasError('client')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('client')"></strong>
                </span>                 
            </div>
         </div>
        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <div>
                <h2 v-if="!newClaim" class="h2">
                    <a href="javascript:void(0)" class="mr-2" role="button" @click="collapsed = !collapsed">
                        <i :class="['fas text-muted', collapsed ? 'fa-caret-right' : 'fa-caret-down']"></i>
                    </a>                    
                    {{ patientName }}
                </h2>
            </div>        
            <div v-if="!readonly" class="btn-group" role="toolbar" aria-label="Form Toolbar">                             
                <button v-if="newClaim" id="uploadForm" class="btn btn-primary"  data-toggle="tooltip" title="Upload File" @click="uploadFile" :disabled="!clientId"><i class="fas fa-file-upload"></i></button>             
                <button v-else id="generateForm" class="btn btn-primary" data-toggle="tooltip" title="Generate Form 1010" @click="generateForm" :disabled="!clientId"><i class="fas fa-file-pdf"></i></button>
                <claim-share-button v-if="shareVisible" :shared="isShared" @click="toggleSharing" :disabled="true"></claim-share-button>
                <button id="saveForm" class="btn btn-primary" data-toggle="tooltip" title="Save Claim" @click="save()" :disabled="!clientId"><i class="fas fa-save"></i></button>
            </div>
        </div>
        <form v-if="!collapsed" id="claimForm" :method="method" :action="action" class="mt-4" novalidate>            
            <nav class="mb-4">
                <div class="nav nav-tabs" id="claimTab">
                    <a class="nav-item nav-link active" id="nav-patient-tab" data-toggle="tab" href="#nav-patient" role="tab" aria-controls="nav-patient" aria-selected="true">Patient</a>
                    <a class="nav-item nav-link" id="nav-employer-tab" data-toggle="tab" href="#nav-employer" role="tab" aria-controls="nav-employer" aria-selected="false">Employer</a>
                    <a class="nav-item nav-link" id="nav-payer-tab" data-toggle="tab" href="#nav-payer" role="tab" aria-controls="nav-payer" aria-selected="false">Payer</a>
                    <a class="nav-item nav-link" id="nav-provider-tab" data-toggle="tab" href="#nav-provider" role="tab" aria-controls="nav-provider" aria-selected="false">Provider</a>
                    <a class="nav-item nav-link" id="nav-treatment-tab" data-toggle="tab" href="#nav-treatment" role="tab" aria-controls="nav-treatment" aria-selected="false">Diagnosis & Treatment</a>
                </div>
            </nav>
            <div class="tab-content pb-3 border-bottom" id="nav-tabContent">
                <div class="tab-pane fade show active" id="nav-patient" role="tabpanel" aria-labelledby="nav-patient-tab">
                    <patient-component :isNew="newClaim" v-bind:model="model.patient" v-bind:states="model.states" v-bind:readonly="readonly || !clientId" v-bind:errors="errors"></patient-component>
                </div>
                <div class="tab-pane fade show" id="nav-employer" role="tabpanel" aria-labelledby="nav-employer-tab">
                    <employer-component :isNew="newClaim" v-bind:model="model.employer" v-bind:states="model.states" v-bind:readonly="readonly || !clientId" v-bind:errors="errors"></employer-component>
                </div>                
                <div class="tab-pane fade show" id="nav-payer" role="tabpanel" aria-labelledby="nav-payer-tab">
                    <payer-component :payers="payers" v-bind:states="model.states" :contacts="contacts" v-bind:readonly="readonly || !clientId" v-bind:model="model.payer" v-bind:errors="errors"></payer-component>
                </div>
                <div class="tab-pane fade show" id="nav-provider" role="tabpanel" aria-labelledby="nav-provider-tab">
                    <provider-component v-bind:clientId="clientId" :providers="providers" v-bind:states="model.states" v-bind:model="model.provider" v-bind:readonly="readonly || !clientId" v-bind:errors="errors"></provider-component>
                </div>
                <div class="tab-pane fade show" id="nav-treatment" role="tabpanel" aria-labelledby="nav-treatment-tab">
                    <treatment-component v-bind:model="model.provider" v-bind:readonly="readonly || !clientId" v-bind:errors="errors"></treatment-component>
                </div>                               
            </div> 
            <input type="hidden" name="_token" :value="csrf">
            <input type="hidden" name="generate" value="false"> 
        </form>
    </div>  
</template>

<script>
import PatientComponent from './PatientComponent.vue';
import EmployerComponent from './EmployerComponent.vue';
import PayerComponent from './PayerComponent.vue';
import ProviderComponent from './ProviderComponent.vue';
import TreatmentComponent from './TreatmentComponent.vue';
import AttorneyInfoComponent from './AttorneyInfoComponent.vue';
import { AttorneyType, DocumentType } from '../../constants.js';
import ClaimShareButton from '../buttons/ClaimShareButtonComponent.vue';
import DuplicateClaimModal from '../DuplicateClaimModalComponent.vue';

export default {
    components: {
        PatientComponent,
        EmployerComponent,
        PayerComponent,
        ProviderComponent,
        TreatmentComponent,
        AttorneyInfoComponent,
        ClaimShareButton,
        DuplicateClaimModal    
    },
    props: {
        newClaim: Boolean,
        readonly: Boolean,
        model: Object,
        errorList: Object,
        isCollapsed: Boolean,
        href: String
    },
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            method: 'post',
            action: this.newClaim ? '/provider/claims' :'/provider/claims/' + this.model.claim_id,
            clientId: this.model.client_id ? this.model.client_id : 0,
            providers: this.model.providers,
            payers: this.model.payers,
            contacts: this.model.contacts,
            shareVisible: this.model.attorney_share_visible,
            isShared: this.model.is_shared,
            collapsed: this.isCollapsed,

            // this allows us to use imported objects in the template
            DocumentType: DocumentType,
            errors: this.errorList          
        }
    },
    computed: {
        patientName: function () {
            return this.model.patient.last_name + 
                (this.model.patient.first_name ? (', ' + this.model.patient.first_name) : '') + 
                (this.model.patient.middle_name ? (' ' + this.model.patient.middle_name) : '');
        }
    },  
    methods: {
        uploadFile: function() {
            let clientId = $('#client').val();
            let data = {
                claimId: this.model.claim_id,
                clientId: clientId,
                url: '/ajax/clients/' + clientId + '/claims/upload/new',
                options: [ 
                    { id: DocumentType.LWC_FORM_1010, name: 'LWC Form 1010' },
                    { id: DocumentType.EDI_837, name: 'EDI 837' }
                ],
                documentType: DocumentType.LWC_FORM_1010
            };            
            eventHub.$emit('show-file-upload', data);
        },
        generateForm: function() {
            $('input[name="generate"]').val('true');
            $('#spinner').modal('show');
            $('#claimForm').submit();           
        },
        save: function() {

            // check to see if a record already exists
            axios.post(`/ajax/clients/${this.clientId}/claims/exists`, {
                claim_id: this.model.claim_id ?? null,
                last_name: this.model.patient.last_name,
                dob: this.model.patient.dob,
                injury_date: this.model.patient.injury_date,
                claim_number: this.model.payer.claim_number
            })
            .then(response => {

                if (response.data.claims.length) {

                    const allowContinue = (response.data.claims.filter(x => x.is_duplicate).length === 0) || !this.newClaim;
                    eventHub.$emit('show-duplicate-claim-modal', response.data.title, response.data.message, response.data.claims, allowContinue, this.continue);
                }
                else {
                    this.continue();
                }
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        continue: function () {
            $('input[name="generate"]').val('false');
            $('#claimForm').submit();
        },
        hasError: function (name) {
            return this.errors.hasOwnProperty(name);
        },
        errorText: function (name) {
            return this.errors[name][0];
        },
        sendClientEvent: function () {
            var self = this;
            var client = this.model.clients.find(function (value) { return value.id == self.clientId });
            eventHub.$emit('claim-client-changed', client);
        },
        onClientChange: function (e) {

            // this will update the client fax number on the file upload modal
            this.sendClientEvent();

            axios.get('/ajax/clients/' + e.target.value + '/options')
                .then((response) => {
                    this.providers = response.data.providers;
                    this.payers = response.data.payers;
                    this.contacts = response.data.contacts;
                })
                .catch((error) => {
                    // TODO: handle error
                });
        },
        toggleSharing: function (shared) {

            let url = `/ajax/shared-claims/${this.model.claim_id}`;
            let method = shared ? 'delete' : 'post';

            axios({ method, url })
                .then(response => {
                    toastr[response.data.level](response.data.message, response.data.title, { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
                })
                .catch(error => {
                    toastr['error'](error.response.data.message, 'ERROR', { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
                });            
        },
        updateShare: function (visible, isShared) {
            this.shareVisible = visible;
            this.isShared = isShared;
        },
        updateAttorney: function (type, value) {
            if (type === AttorneyType.EMPLOYEE_ATTORNEY) {
                this.model.patient.attorney = value;
            }
            else if (type === AttorneyType.EMPLOYER_ATTORNEY) {
                this.model.employer.attorney = value;
            }
        }
    },
    created() {

        this.generate = false;
              
        eventHub.$on('claim-share-event', this.updateShare);

        // if only one client pre-select the client
        if (this.model.clients.length == 1) {
            this.clientId = this.model.clients[0].id;
        }

        if (Object.keys(this.errors).length > 0) {

            let message = 'Please check all tabs for errors. There were problems with the following fields:';
            message += '<ul>';
            Object.values(this.errors).forEach(value => {
                message += `<li>${value}</li>`;
            });
            message += '</ul>';

            toastr['error'](message, '', {"timeOut": 10000, "positionClass": "toast-top-full-width", "closeButton": true});
        }
    },
    mounted() {

        // notify any listeners of the selected client
        this.sendClientEvent();
    },
    beforeDestroy() {
        eventHub.$off('claim-share-event');
    },
}
</script>

<style scoped>
    .claim-status {
        font-family: 'Allerta Stencil', sans-serif;
        font-weight: bold;
        font-size: 2.0em;
    }

    .status-button {
        opacity: 0;
    }

    .status-button:hover {
        opacity: 1;
    }

    .share-documents {
        position: relative;
        top: 4px;
        font-size: 1.25em;
    }

    .share-badge {
        position: relative;
        top: -12px;
        left: 12px;
        display: inline-block;
        font-size: .50em;        
    }
</style>


